/* assets/pb.js */
(function () {
  // Support both id="pb-..." and data-pb-root
  const roots = Array.from(document.querySelectorAll('section[id^="pb-"], [data-pb-root]'));
  if (!roots.length) return;

  // -------- utils --------
  function money(cents, currency) {
    const locale = (window.Shopify && Shopify.locale) || navigator.language || 'en-AU';
    const cur =
      (window.Shopify && Shopify.currency && (Shopify.currency.active || Shopify.currency)) ||
      currency ||
      'AUD';
    return new Intl.NumberFormat(locale, { style: 'currency', currency: cur }).format(
      (Number(cents) || 0) / 100
    );
  }

  function safeJSON(text, fallback) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return fallback;
    }
  }

  // Prefer <script data-products-json>, then data-products, else synthesize from legacy
  function readProductsPayload(card) {
    const script = card.querySelector('script[data-products-json]');
    if (script && script.textContent) {
      const arr = safeJSON(script.textContent.trim(), []);
      if (Array.isArray(arr) && arr.length) return arr;
    }

    const attrArr = safeJSON(card.getAttribute('data-products') || '[]', []);
    if (Array.isArray(attrArr) && attrArr.length) return attrArr;

    // Legacy fallbacks
    const legacyOpts = safeJSON(card.getAttribute('data-option-names') || '[]', []);
    const legacyVars = safeJSON(card.getAttribute('data-variants') || '[]', []);

    if (Array.isArray(legacyVars) && legacyVars.length) {
      return [
        {
          id: card.getAttribute('data-product-id') || null,
          title: card.getAttribute('data-product-title') || '',
          options: Array.isArray(legacyOpts) ? legacyOpts : [],
          images: [],
          variants: legacyVars,
        },
      ];
    }
    return [];
  }

  function setImgEl(card, src1200, src600, alt) {
    const imgEl = card.querySelector('.ProductItem__Image');
    if (!imgEl || !src1200) return false;
    imgEl.src = src1200;
    imgEl.srcset = `${src600 || src1200} 600w, ${src1200} 1200w`;
    imgEl.alt = alt || imgEl.dataset.baseAlt || imgEl.alt;
    return true;
  }

  function setImageToProductBase(card, product) {
    const imgEl = card.querySelector('.ProductItem__Image');
    if (!imgEl || !product) return;
    const fi = product.featured_image;
    let src1200 = null,
      src600 = null,
      alt = product.title || imgEl.alt || '';

    if (fi && typeof fi === 'object') {
      src1200 = fi.src1200 || fi.src || null;
      src600 = fi.src600 || src1200;
      alt = fi.alt || alt;
    } else if (typeof fi === 'string') {
      src1200 = fi;
      src600 = fi;
    }

    if (src1200) {
      imgEl.src = src1200;
      imgEl.srcset = `${src600 || src1200} 600w, ${src1200} 1200w`;
      imgEl.alt = alt;
      imgEl.dataset.baseSrc600 = src600 || src1200;
      imgEl.dataset.baseSrc1200 = src1200;
      imgEl.dataset.baseAlt = alt;
    }
  }

  function getVariantDirectSources(variant) {
    const m = variant && variant.image;
    if (!m) return { src1200: null, src600: null, alt: null, media_id: null };
    if (typeof m === 'string') return { src1200: m, src600: m, alt: null, media_id: null };
    const src1200 = m.src1200 || m.src || m.url1200 || m.url || null;
    const src600 = m.src600 || m.url600 || src1200 || null;
    const alt = m.alt || null;
    const mediaId = m.media_id || m.id || null;
    return { src1200, src600, alt, media_id: mediaId };
  }

  function fromGalleryById(product, mediaId) {
    if (!product || !Array.isArray(product.images) || !mediaId) return null;
    return product.images.find((im) => String(im.id) === String(mediaId)) || null;
  }

  function tryHeuristicProductImage(card, product, selectedOptions) {
    const imgEl = card.querySelector('.ProductItem__Image');
    if (!imgEl || !product || !Array.isArray(product.images)) return false;
    const needle = (selectedOptions || []).filter(Boolean).join(' ').toLowerCase();
    if (!needle) return false;
    let best = null;
    for (const im of product.images) {
      const alt = (im.alt || '').toLowerCase();
      if (!alt) continue;
      if (alt.includes(needle)) {
        best = im;
        break;
      }
      const tokens = needle.split(/\s+/).filter(Boolean);
      if (!best && tokens.some((t) => alt.includes(t))) best = im;
    }
    if (best) {
      const s1200 = best.src1200 || best.src || null;
      const s600 = best.src600 || s1200 || null;
      return setImgEl(card, s1200, s600, best.alt || '');
    }
    return false;
  }

  function inferOptionNamesFromVariants(variants) {
    const first = Array.isArray(variants) ? variants.find((v) => Array.isArray(v.options)) : null;
    const count = first ? first.options.length : 0;
    if (!count) return [];
    const names = [];
    for (let i = 0; i < count; i++) names.push(i === 0 ? 'Size' : i === 1 ? 'Color' : `Option ${i + 1}`);
    return names;
  }

  // Create missing option rows if the markup doesn't include them
  function getOrCreateOptionRows(card, needed) {
    const container = card.querySelector('[data-options]');
    if (!container) return [];
    let rows = Array.from(card.querySelectorAll('[data-opt]'));
    const makeRow = (idx) => {
      const row = document.createElement('div');
      row.className = 'ProductForm__Option';
      row.setAttribute('data-opt', '');
      row.setAttribute('data-opt-index', String(idx));
      row.setAttribute('data-opt-name', '');
      row.style.display = 'none';
      row.hidden = true;

      const label = document.createElement('div');
      label.className = 'ProductForm__Label';
      row.appendChild(label);

      const wrap = document.createElement('div');
      wrap.className = 'ProductForm__OptionValues';
      wrap.setAttribute('data-opt-values', '');
      row.appendChild(wrap);

      container.appendChild(row);
      return row;
    };

    for (let i = rows.length; i < needed; i++) rows.push(makeRow(i));
    return Array.from(card.querySelectorAll('[data-opt]'));
  }

  // -------- per-root init --------
  roots.forEach((root) => {
    // Optional config
    const cfgScript = root.querySelector('script[data-pb-config]');
    const cfg = cfgScript && cfgScript.textContent ? safeJSON(cfgScript.textContent.trim(), {}) : {};
    const requireSameSize = !!cfg.requireSameSize;
    const sizeOptionNameLC = (cfg.sizeOptionName || 'Size').toString().toLowerCase();
    const displayDiscountPct = Number(cfg.displayDiscountPct || 0);
    const bundleName = cfg.bundleName || 'Custom Bundle';
    const addingLabel = cfg.addingLabel || 'Adding…';
    const discountCode = (cfg.discountCode || '').toString();
    const applyDiscount = !!cfg.applyDiscountOnAdd;
    const strictBundleDiscount = cfg.strictBundleDiscount !== false; // default true
    const shopCurrency =
      cfg.currency ||
      ((window.Shopify && (Shopify.currency?.active || Shopify.currency)) || 'AUD');

    const addBtn = root.querySelector('[data-add]');
    const totalPriceEl = root.querySelector('[data-total-price]');
    const totalCompareEl = root.querySelector('[data-total-compare]');
    const saveWrap = root.querySelector('[data-save-wrap]');
    const saveAmountEl = root.querySelector('[data-save-amount]');
    const globalStatus = root.querySelector('[data-global-status]');

    let cards = []; // declare before functions

    function totalRefresh() {
      if (!cards.length || !totalPriceEl || !totalCompareEl) return;
      const sum = cards.reduce((m, c) => m + c.getPrice(), 0);
      const cmp = cards.reduce((m, c) => m + c.getCompare(), 0);
      let displaySum = sum;
      if (displayDiscountPct > 0) displaySum = Math.round((sum * (100 - displayDiscountPct)) / 100);

      if (cmp > sum) {
        totalCompareEl.style.display = '';
        totalCompareEl.textContent = money(cmp, shopCurrency);
      } else {
        totalCompareEl.style.display = 'none';
        totalCompareEl.textContent = '';
      }

      totalPriceEl.textContent = money(displaySum, shopCurrency);

      if (saveWrap && saveAmountEl) {
        if (displayDiscountPct > 0) {
          const save =
            cmp > sum ? cmp - sum : Math.round(sum * (displayDiscountPct / 100));
          saveWrap.style.display = '';
          saveAmountEl.textContent = money(Math.max(0, save), shopCurrency);
        } else {
          saveWrap.style.display = 'none';
        }
      }

      if (addBtn && globalStatus) {
        const allBuyable = cards.length && cards.every((c) => c.isBuyable());
        addBtn.disabled = !allBuyable;
        globalStatus.textContent = allBuyable
          ? ''
          : 'Choose available options for all components.';
      }
    }

    async function refreshCartUI() {
      let cart = null;
      try {
        cart = await fetch('/cart.js').then((r) => r.json());
      } catch (e) {}
      ['cart:updated', 'cart:change', 'theme:cart:update', 'cart:refresh'].forEach((n) => {
        try {
          document.dispatchEvent(new CustomEvent(n, { detail: { cart } }));
        } catch (e) {}
      });
      const drawer = document.querySelector('cart-drawer, [data-cart-drawer], #CartDrawer');
      if (drawer) {
        try {
          if (typeof drawer.renderContents === 'function' && cart) {
            drawer.renderContents(cart);
            return;
          }
          drawer.setAttribute('open', '');
          return;
        } catch (e) {}
      }
      if (!document.body.classList.contains('template-cart')) window.location.href = '/cart';
    }

    // NEW: small helper to read cart (used to decide if we should apply discount)
    async function fetchCart() {
      try { return await fetch('/cart.js').then(r => r.json()); }
      catch(e){ return null; }
    }

    // Only true if all items in cart belong to our bundleId
    function isCartPureBundle(cart, bundleId) {
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return false;
      return cart.items.every(it => it.properties && it.properties._bundle_id === bundleId);
    }

    // Build all cards
    const cardEls = Array.from(root.querySelectorAll('article.ProductItem'));
    cards = cardEls.map((card, idx) => {
      const products = readProductsPayload(card);
      if (!Array.isArray(products) || !products.length) {
        console.warn('[PB] Card has no products; disabling', card);
        return {
          getVariant() {
            return null;
          },
          getPrice() {
            return 0;
          },
          getCompare() {
            return 0;
          },
          isBuyable() {
            return false;
          },
        };
      }

      const switcher = card.querySelector('[data-switch]');
      let activeIdx = 0;
      let current = products[activeIdx] || { options: [], variants: [], images: [] };

      const statusEl = card.querySelector('[data-status]');
      const priceEl = card.querySelector('[data-price]');

      // Build / ensure option rows exist
      const inferredNames = (Array.isArray(current.options) && current.options.length)
        ? current.options
        : inferOptionNamesFromVariants(current.variants || []);
      let optRows = getOrCreateOptionRows(card, Math.max(inferredNames.length, 1)); // at least 1 row if variants exist

      function optionNames() {
        const names = Array.isArray(current.options) ? current.options : [];
        if (names.length) return names;
        return inferOptionNamesFromVariants(current.variants || []);
      }

      function showRows(count) {
        optRows = getOrCreateOptionRows(card, count);
        optRows.forEach((row, i) => {
          if (i < count) {
            row.style.removeProperty('display');
            row.hidden = false;
          } else {
            row.style.display = 'none';
            row.hidden = true;
          }
        });
      }

      function buildOptionUI() {
        const names = optionNames();
        const variants = current.variants || [];
        const count = names.length || (variants[0]?.options?.length || 0);

        showRows(count);

        optRows.forEach((row, optIndex) => {
          const label = row.querySelector('.ProductForm__Label');
          if (label) label.textContent = names[optIndex] || `Option ${optIndex + 1}`;
          const wrap = row.querySelector('[data-opt-values]');
          if (!wrap) return;
          wrap.innerHTML = '';

          if (!wrap._pbDelegated) {
            wrap.addEventListener('click', (ev) => {
              const t = ev.target.closest('[data-value]');
              if (!t) return;
              if (t.hasAttribute('disabled') || t.classList.contains('Pill--disabled')) return;
              selectOpt(optIndex, t.getAttribute('data-value'));
            });
            wrap._pbDelegated = true;
          }

          const values = new Set();
          variants.forEach((v) => {
            const arr = Array.isArray(v.options) ? v.options : [];
            const val = arr[optIndex];
            if (val && val !== 'Default Title') values.add(val);
          });

          // If no values (e.g., single-variant product), still render one inert pill with the title
          if (!values.size && variants.length && Array.isArray(variants[0].options)) {
            const val = variants[0].options[optIndex] || variants[0].title || 'Default';
            values.add(val);
          }

          Array.from(values).forEach((val) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'Pill';
            b.dataset.value = val;
            b.textContent = val;
            wrap.appendChild(b);
          });
        });
      }

      const state = { selected: [], variant: null };

      function paintPrice() {
        if (!priceEl) return;
        if (state.variant) {
          const c = state.variant.compare_at_price || state.variant.price;
          priceEl.innerHTML =
            c > state.variant.price
              ? `<span class="Price__Compare Text--subdued" style="text-decoration:line-through;margin-right:.4rem;">${money(
                  c,
                  shopCurrency
                )}</span><strong>${money(state.variant.price, shopCurrency)}</strong>`
              : `<strong>${money(state.variant.price, shopCurrency)}</strong>`;
        } else {
          priceEl.textContent = '--';
        }
      }

      function refreshPills() {
        const names = optionNames();
        const variants = current.variants || [];
        optRows.forEach((row, idx2) => {
          row.querySelectorAll('[data-value]').forEach((p) => {
            const val = p.getAttribute('data-value');
            const exists = variants.some((v) => {
              const vopts = Array.isArray(v.options) ? v.options : [];
              const hypo = state.selected.slice();
              hypo[idx2] = val;
              return (names.length ? names : vopts.map((_, i) => `Option ${i + 1}`)).every(
                (_, ii) => !hypo[ii] || hypo[ii] === vopts[ii]
              );
            });
            p.classList.toggle('Pill--disabled', !exists);
            if (exists) p.removeAttribute('disabled');
            else p.setAttribute('disabled', '');
            p.setAttribute('aria-disabled', String(!exists));

            const selected = state.selected[idx2] === val;
            p.classList.toggle('Pill--active', selected);
            p.setAttribute('aria-pressed', String(selected));
          });
        });
      }

      function applySelectionFromVariant(v) {
        const names = optionNames();
        const count = names.length || (Array.isArray(v?.options) ? v.options.length : 0);
        if (count) showRows(count);

        state.selected =
          v && Array.isArray(v.options) ? v.options.slice() : Array(count).fill(null);
        state.variant = v || null;

        // Image resolution chain
        const direct = getVariantDirectSources(v || {});
        if (direct.src1200 && setImgEl(card, direct.src1200, direct.src600, direct.alt)) {
          paintPrice();
          return;
        }
        if (direct.media_id) {
          const g = fromGalleryById(current, direct.media_id);
          if (g && setImgEl(card, g.src1200 || g.src, g.src600 || g.src1200, g.alt)) {
            paintPrice();
            return;
          }
        }
        if (tryHeuristicProductImage(card, current, state.selected)) {
          paintPrice();
          return;
        }
        setImageToProductBase(card, current);
        paintPrice();
      }

      function selectOpt(i, value) {
        state.selected[i] = value;

        if (requireSameSize) {
          const names = optionNames();
          if ((names[i] || '').toLowerCase() === sizeOptionNameLC) {
            document.dispatchEvent(
              new CustomEvent('pb:size', { detail: { name: names[i], value, source: card } })
            );
          }
        }
        resolveVariant();
      }

      function resolveVariant() {
        const names = optionNames();
        const variants = current.variants || [];
        const match =
          variants.find((v) => {
            const vopts = Array.isArray(v.options) ? v.options : [];
            if (!vopts.length && names.length) return false;
            const wanted = state.selected;
            // Allow partial matches while building selection
            return (names.length ? names : vopts.map((_, i) => `Option ${i + 1}`)).every(
              (_, ii) => !wanted[ii] || wanted[ii] === vopts[ii]
            );
          }) || null;

        state.variant = match;
        if (statusEl)
          statusEl.textContent = match
            ? match.available
              ? ''
              : 'This combination is sold out.'
            : 'This combination doesn’t exist.';
        refreshPills();
        applySelectionFromVariant(state.variant);
        totalRefresh();
      }

      // Cross-card size sync
      if (requireSameSize) {
        document.addEventListener('pb:size', (e) => {
          if (e.detail.source === card) return;
          const names = optionNames();
          const idxName = names.findIndex(
            (n) => n && n.toLowerCase() === (e.detail.name || '').toLowerCase()
          );
          if (idxName >= 0) {
            const wrap = optRows[idxName]?.querySelector('[data-opt-values]');
            const pill = wrap?.querySelector(
              `[data-value="${CSS.escape(String(e.detail.value))}"]`
            );
            const disabled =
              pill && (pill.classList.contains('Pill--disabled') || pill.hasAttribute('disabled'));
            if (pill && !disabled) pill.click();
          }
        });
      }

      // Product A/B switcher
      if (switcher && products.length > 1) {
        switcher.querySelectorAll('button[data-product-idx]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const next = parseInt(btn.dataset.productIdx, 10);
            if (Number.isNaN(next) || next === activeIdx) return;
            activeIdx = next;
            current = products[activeIdx] || { options: [], variants: [], images: [] };

            switcher.querySelectorAll('button').forEach((b) =>
              b.classList.toggle('Pill--active', b === btn)
            );

            // Rebuild option UI for the new product
            buildOptionUI();
            setImageToProductBase(card, current);

            const v =
              (current.variants || []).find((x) => x && x.available) ||
              (current.variants || [])[0] ||
              null;
            applySelectionFromVariant(v);
            refreshPills();
            totalRefresh();
          });
        });
      }

      // ---- init this card ----
      buildOptionUI();
      setImageToProductBase(card, current);

      const initial =
        (current.variants || []).find((x) => x && x.available) ||
        (current.variants || [])[0] ||
        null;
      applySelectionFromVariant(initial);
      refreshPills();

      return {
        getVariant() {
          return state.variant;
        },
        getPrice() {
          return state.variant ? state.variant.price : 0;
        },
        getCompare() {
          return state.variant ? state.variant.compare_at_price || state.variant.price : 0;
        },
        isBuyable() {
          return !!(state.variant && state.variant.available);
        },
      };
    });

    totalRefresh();

    // Add to cart (bundle)
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        if (!cards.length) {
          if (globalStatus) globalStatus.textContent = 'No components configured.';
          return;
        }
        const bad = cards.find((c) => !c.isBuyable());
        if (bad) {
          if (globalStatus) globalStatus.textContent = 'A selected combination is unavailable.';
          return;
        }
        if (globalStatus) globalStatus.textContent = '';

        const bundleId = 'pb-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        const items = cards.map((c) => {
          const v = c.getVariant();
          return {
            id: v.id,
            quantity: 1,
            properties: {
              _bundle_id: bundleId,
              _bundle_name: bundleName,
              _component_label: v ? v.title : '',
            },
          };
        });

        addBtn.disabled = true;
        addBtn.setAttribute('aria-busy', 'true');
        const labelSpan = addBtn.querySelector('.add-to-cart-text__content');
        const prev = labelSpan ? labelSpan.textContent : addBtn.textContent;
        if (labelSpan) labelSpan.textContent = addingLabel;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('add failed');

          if (globalStatus) globalStatus.textContent = 'Bundle added to cart.';

          // Decide whether to auto-apply discount:
          // Only do it if the cart now contains ONLY this bundle's items.
          const cartAfter = await fetchCart();
          const eligibleForAutoCode =
            applyDiscount &&
            discountCode &&
            discountCode.trim().length &&
            discountCode.toUpperCase() !== 'DISABLED' &&
            (!strictBundleDiscount || isCartPureBundle(cartAfter, bundleId));

          if (eligibleForAutoCode) {
            window.location.assign(`/discount/${encodeURIComponent(discountCode)}?redirect=/cart`);
            return;
          } else if (strictBundleDiscount && globalStatus && discountCode) {
            // Optional message for clarity
            globalStatus.textContent =
              'Bundle discount applies only to bundle items. Code not auto-applied because other items are in your cart.';
          }

          addBtn.classList.add('atc-added');
          setTimeout(() => addBtn.classList.remove('atc-added'), 1200);

          await refreshCartUI();
        } catch (e) {
          if (globalStatus) globalStatus.textContent = 'Sorry, something went wrong adding the bundle.';
        } finally {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-busy');
          const labelSpan2 = addBtn.querySelector('.add-to-cart-text__content');
          if (labelSpan2) labelSpan2.textContent = prev;
        }
      });
    }
  });
})();
